import ReCAPTCHA from "react-google-recaptcha";

export const checkReCaptcha = async (
  myRef: React.RefObject<ReCAPTCHA>
): Promise<string | null> => {
  if (!myRef?.current) return null;

  const recaptchaToken = await myRef.current.executeAsync();

  if (!recaptchaToken) return null;

  return recaptchaToken;
};
